<template>
    <b-navbar toggleable="xl" type="dark" class="navbar-box">
        <b-navbar-brand class="nav-logo" :to="'/'">
            <b-img src="/images/03_LVI_logo_inv_LV.png" class="logo"></b-img>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <!-- <b-nav-form> -->
                <b-nav-item
                    ><b-button
                        class="button-primary-ds navigation-button"
                        type="submit"
                        :to="'/'"
                        >Sākums</b-button
                    ></b-nav-item
                >
                <b-nav-item>
                    <b-button
                        size="sm"
                        class="button-primary-ds navigation-button"
                        type="submit"
                        :to="'/par-mums'"
                    >
                        Par mums</b-button
                    ></b-nav-item
                >
                <b-nav-item>
                    <b-button
                        size="sm"
                        class="button-primary-ds navigation-button"
                        type="submit"
                        :to="'/par-projektu'"
                    >
                        Par projektu</b-button
                    ></b-nav-item
                >
                <b-nav-item>
                    <b-button
                        size="sm"
                        class="button-primary-ds navigation-button"
                        type="submit"
                        :to="'/interaktiva-karte'"
                    >
                        Interaktīvā karte</b-button
                    ></b-nav-item
                >
                <b-nav-item>
                    <b-button
                        size="sm"
                        class="button-primary-ds navigation-button"
                        type="submit"
                        :to="'/lvda-2022'"
                    >
                        LVDA (2022)</b-button
                    ></b-nav-item
                >
                <b-nav-item>
                    <b-button
                        size="sm"
                        class="button-primary-ds navigation-button"
                        type="submit"
                        v-if="authenticated"
                        :to="'/lietotaja-konts'"
                        >Lietotāja konts</b-button
                    >
                </b-nav-item>
                <b-nav-item>
                    <b-button
                        size="sm"
                        class="button-primary-ds navigation-button"
                        type="submit"
                        v-if="authenticated"
                        :to="'/administracija/sakums'"
                        >Administracija</b-button
                    ></b-nav-item
                >
                <b-nav-item>
                    <b-button
                        size="sm"
                        class="button-primary-ds navigation-button"
                        type="submit"
                        v-if="authenticated"
                        @click="logout()"
                        >Iziet</b-button
                    ></b-nav-item
                >
                <!-- </b-nav-form> -->
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "appNavigation",
    components: {},
    data: () => ({}),
    computed: {
        ...mapGetters({
            authenticated: "auth/authenticated",
            user: "auth/user",
        }),
    },
    methods: {
        ...mapActions({
            signOut: "auth/signOut",
        }),
        async logout() {
            await this.signOut().then(() => {
                this.$bvToast.toast("Lietotājs veiksmīgi izrakstijies", {
                    title: "Darbības apstiprinājums",
                    variant: "success",
                });
                this.$router.push({ name: "home" }).catch(() => {});
            });
        },
        openOtherApp() {
            window.open("https://vietvardi.lv/talka/", "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/app.scss";

.navbar-box {
    border-bottom: 1px solid $red400 !important;
    border-left: none !important;
    background: $red400;
    height: 70px;
}

.nav-logo {
    margin-left: 12px;
}

.navigation-button {
    border: none;
    background-color: $red400 !important;
    color: $white !important;
    padding: 8px 24px 8px 24px !important;

    &:hover {
        background-color: $red500 !important;
    }
    font-weight: 700 !important;
    font-size: 14px !important;
}

.logo {
    width: 184px;
}

@media (max-width: $xl-media) {
    #nav-collapse {
        // background: #C2C2C3;
        background: $content-background;

        opacity: 1;
        z-index: 2;
    }
    .navigation-button {
        width: 100%;
        background-color: $grey000 !important;
        color: $red400 !important;

        &:hover {
            background-color: $grey000 !important;
        }
    }
}
</style>
